var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	84047: () => (loadSingletonVersion("default", "@angular/core", false, [1,21,2,21], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	55883: () => (loadSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	59905: () => (loadSingletonVersion("default", "@angular/common", false, [1,21,2,21], () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	76662: () => (loadSingletonVersion("default", "@angular/platform-browser", false, [1,21,2,21], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	76883: () => (loadSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	17789: () => (loadSingletonVersion("default", "@angular/core/primitives/di", false, [1,21,2,21], () => (__webpack_require__.e(8513).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))))),
	63205: () => (loadSingletonVersion("default", "@angular/core/primitives/signals", false, [1,21,2,21], () => (__webpack_require__.e(9080).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))))),
	48227: () => (loadSingletonVersion("default", "@angular/common/http", false, [1,21,2,21], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	25053: () => (loadSingletonVersion("default", "@angular/router", false, [1,21,2,21], () => (__webpack_require__.e(2691).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	28531: () => (loadSingletonVersion("default", "jszip", false, [1,3,10,1], () => (__webpack_require__.e(5834).then(() => (() => (__webpack_require__(/*! jszip */ 45834))))))),
	226: () => (loadSingletonVersion("default", "chart.js", false, [1,4,5,1], () => (__webpack_require__.e(6792).then(() => (() => (__webpack_require__(/*! chart.js */ 36792))))))),
	4937: () => (loadSingletonVersion("default", "@angular/cdk/overlay", false, [1,21,2,14], () => (__webpack_require__.e(9189).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))))),
	16510: () => (loadSingletonVersion("default", "@cvx/cal-angular", false, [1,21,0,2], () => (__webpack_require__.e(1991).then(() => (() => (__webpack_require__(/*! @cvx/cal-angular */ 71991))))))),
	31505: () => (loadSingletonVersion("default", "@angular/cdk/drag-drop", false, [1,21,2,14], () => (__webpack_require__.e(8473).then(() => (() => (__webpack_require__(/*! @angular/cdk/drag-drop */ 50854))))))),
	32359: () => (loadSingletonVersion("default", "@angular/cdk/portal", false, [1,21,2,14], () => (__webpack_require__.e(6787).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	33643: () => (loadSingletonVersion("default", "@angular/platform-browser/animations/async", false, [1,21,2,21], () => (__webpack_require__.e(9192).then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations/async */ 39192))))))),
	34626: () => (loadSingletonVersion("default", "marked", false, [1,15,0,0], () => (__webpack_require__.e(997).then(() => (() => (__webpack_require__(/*! marked */ 60997))))))),
	38123: () => (loadSingletonVersion("default", "handsontable", false, [1,17,1,0], () => (__webpack_require__.e(1569).then(() => (() => (__webpack_require__(/*! handsontable */ 73950))))))),
	50395: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop", false, [1,21,2,21], () => (__webpack_require__.e(6693).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))))),
	59931: () => (loadSingletonVersion("default", "@angular/cdk/dialog", false, [1,21,2,14], () => (__webpack_require__.e(1101).then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 93482))))))),
	83723: () => (loadSingletonVersion("default", "@angular/forms", false, [1,21,2,21], () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	21731: () => (loadSingletonVersion("default", "@angular/animations/browser", false, [1,21,2,21], () => (__webpack_require__.e(3036).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))))),
	52720: () => (loadSingletonVersion("default", "exceljs", false, [1,4,4,0], () => (__webpack_require__.e(4058).then(() => (() => (__webpack_require__(/*! exceljs */ 54058))))))),
	68662: () => (loadSingletonVersion("default", "file-saver", false, [1,2,0,5], () => (__webpack_require__.e(5841).then(() => (() => (__webpack_require__(/*! file-saver */ 85841))))))),
	36245: () => (loadSingletonVersion("default", "html2canvas", false, [1,1,4,1], () => (__webpack_require__.e(822).then(() => (() => (__webpack_require__(/*! html2canvas */ 60822))))))),
	73062: () => (loadSingletonVersion("default", "pptxgenjs", false, [1,"file:vendor/pptxgenjs"], () => (__webpack_require__.e(7023).then(() => (() => (__webpack_require__(/*! pptxgenjs */ 47023)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"316": [
		55883,
		84047
	],
	"436": [
		48227,
		59905,
		84047
	],
	"655": [
		84047
	],
	"854": [
		55883,
		59905,
		76883,
		84047
	],
	"1101": [
		76883
	],
	"1570": [
		55883,
		59905,
		76883,
		84047
	],
	"1731": [
		21731
	],
	"1991": [
		76883
	],
	"2075": [
		76883
	],
	"2691": [
		76662,
		76883
	],
	"2720": [
		52720
	],
	"3062": [
		73062
	],
	"3482": [
		55883,
		59905,
		76662,
		76883,
		84047
	],
	"4372": [
		25053,
		48227,
		55883,
		59905,
		76883,
		84047
	],
	"4456": [
		55883,
		59905,
		76883,
		84047
	],
	"5020": [
		226,
		4937,
		16510,
		25053,
		31505,
		32359,
		33643,
		34626,
		38123,
		48227,
		50395,
		55883,
		59905,
		59931,
		76662,
		83723,
		84047
	],
	"5072": [
		55883,
		59905,
		76662,
		76883,
		84047
	],
	"6245": [
		36245
	],
	"6443": [
		55883,
		76883,
		84047
	],
	"6693": [
		17789,
		63205,
		76883
	],
	"6811": [
		59905,
		84047
	],
	"7023": [
		28531
	],
	"7580": [
		17789,
		55883,
		63205,
		76883
	],
	"7935": [
		55883
	],
	"8055": [
		48227
	],
	"8473": [
		76883
	],
	"8662": [
		68662
	],
	"8824": [
		55883,
		76883
	],
	"9074": [
		17789,
		55883,
		63205,
		76883
	],
	"9168": [
		84047
	],
	"9189": [
		76883
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}